// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16DDd","col":"styles_col__3fFr7"};